import axiosInstance from "@/api/axiosInstance";
import { FetchSprintIterationsResponse } from "./types";

export const fetchSprintIterations =
  async (): Promise<FetchSprintIterationsResponse> => {
    const response = await axiosInstance.get<FetchSprintIterationsResponse>(
      "/api/capex/sprint-iterations",
    );
    return response.data;
  };
